<template>
  <component :is="tag" :type="tag === 'button' ? 'button' : null" class="btn btn-secondary" @click="$emit('click')" @mouseover="isBtnHover = true" @mouseleave="isBtnHover = false">
    <slot></slot>
    <icon class="btn-secondary__icon" :name="isBtnHover ? iconNameHover : iconName" width="19" height="19" />
  </component>
</template>

<script>
import Icon from './Icon'

export default {
  components: {
    Icon
  },
  props: {
    iconName: String,
    iconNameHover: String,
    tag: {
      type: String,
      default: 'button'
    }
  },
  data () {
    return {
      isBtnHover: false
    }
  }
}
</script>
